/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Remix Icon License v1.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const VolumeUpFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M2 16h3.89l5.3 4.33a.5.5 0 0 0 .81-.38V4.05a.5.5 0 0 0-.82-.38L5.9 8H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1m21-4c0 3.3-1.45 6.25-3.74 8.26l-1.42-1.42A9 9 0 0 0 21 12a9 9 0 0 0-3.15-6.84l1.41-1.42A11 11 0 0 1 23 12m-5 0a6 6 0 0 0-2.29-4.71l-1.43 1.43A4 4 0 0 1 16 12a4 4 0 0 1-1.72 3.28l1.43 1.43A6 6 0 0 0 18 12" />
  </Icon>
);
